import { BiHomeAlt } from "react-icons/bi";

import {
  FaUserCircle,
  FaUserAstronaut,
  FaImages,
  FaUsers,
  FaParachuteBox,
} from "react-icons/fa";
import { PrivatePaths } from "../../routes/path";
import { GiNewspaper } from "react-icons/gi";
export const adminLinks = [
  {
    route: PrivatePaths.DASHBOARD,
    name: "Dashboard",
    Icon: BiHomeAlt,
    allowed: ["SuperAdmin", "User", "Admin"],
  },
  {
    route: PrivatePaths.CAROUSEL,
    name: "Carousel",
    Icon: FaImages,
    allowed: ["SuperAdmin", "Admin", "User"],
  },

  {
    route: PrivatePaths.TEAM,
    name: "Team",
    Icon: FaUsers,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  {
    route: PrivatePaths.CEO,
    name: "CEO",
    Icon: FaUserAstronaut,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  {
    route: PrivatePaths.SERVICE,
    name: "Service",
    Icon: GiNewspaper,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  {
    route: PrivatePaths.PRODUCT,
    name: "Product",
    Icon: FaParachuteBox,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  {
    route: PrivatePaths.PRODUCT_FEATURE,
    name: "Product Feature",
    Icon: FaParachuteBox,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  {
    route: PrivatePaths.TESTIMONY,
    name: "Testimonial",
    Icon: GiNewspaper,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  {
    route: PrivatePaths.ADMIN,
    name: "Admin",
    Icon: FaUserCircle,
    allowed: ["SuperAdmin", "Admin", "User"],
  },

  {
    route: PrivatePaths.REQUEST,
    name: "Requests",
    Icon: FaUserCircle,
    allowed: ["SuperAdmin", "Admin", "User"],
  },
  // {
  //   route: PrivatePaths.USERS,
  //   name: "Users",
  //   Icon: FaUserShield,
  //   allowed: ["SuperAdmin", "Admin", "User"],
  // },
];
